export const LEARNER = 'LEARNER';
export const EDITOR = 'EDITOR';
export const PREVIEW = 'PREVIEW';
export const VIEWER = 'VIEWER';
export const REVIEW = 'REVIEW';
export const HISTORY = 'HISTORY';
